import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { Location, Position } from '../../types';
import { positionIcon } from '../../config/mapIcons';
import { MAP_CONFIG } from '../../config/mapConfig';
import RecenterButton from './RecenterButton';
import MapController from './MapController';
import MapResizer from './MapResizer';
import './Map.css';

interface MapProps {
  locations: Location[];
  currentPosition: Position | null;
  onLocationSelect: (id: string) => void;
  onMapClick: () => void;
  onRecenter: () => void;
  selectedLocationId: string | null;
}

const Map: React.FC<MapProps> = ({
  locations,
  currentPosition,
  onLocationSelect,
  onMapClick,
  onRecenter,
  selectedLocationId,
}) => {
  const selectedLocation = selectedLocationId 
    ? locations.find(loc => loc.id === selectedLocationId)
    : null;

  return (
    <div className="map-wrapper">
      <MapContainer
        center={MAP_CONFIG.defaultCenter}
        zoom={MAP_CONFIG.defaultZoom}
        style={{ height: '100%', width: '100%' }}
        className="map-container"
      >
        <TileLayer
          url={MAP_CONFIG.tileLayerUrl}
          attribution={MAP_CONFIG.tileLayerAttribution}
        />
        <MapResizer />
        
        <MapController 
          targetPosition={selectedLocation?.position || null}
          zoom={18}
          onMapClick={onMapClick}
        />
        
        <RecenterButton position={currentPosition} onRecenter={onRecenter} />
        
        {locations.map((location) => (
          <Marker
            key={location.id}
            position={location.position}
            icon={location.icon}
            eventHandlers={{
              click: () => onLocationSelect(location.id),
              popupclose: () => onMapClick()
            }}
          >
            <Popup className="custom-popup">
              <div className="popup-content">
                <h3 className="popup-title">{location.name} {location.tracks.length > 1 && `(${location.tracks.length} audios)`}</h3>
                {location.tracks.length > 0 && (
                  <p className="popup-description">Appuyez sur play en bas pour écouter.</p>
                )}
              </div>
            </Popup>
          </Marker>
        ))}
        
        {currentPosition && (
          <Marker position={currentPosition} icon={positionIcon}>
            <Popup className="custom-popup">
              <div className="popup-content">
                <h3 className="popup-title">📍 Votre position</h3>
                <p className="popup-description">Vous êtes ici</p>
              </div>
            </Popup>
          </Marker>
        )}
      </MapContainer>
    </div>
  );
};

export default Map;
